import './LogoBox.css'

export function LogoBox() {
    return (
        <span id='logo-box'>
            <h2>My Local</h2>
            <span id='company-logo-image'></span>
            <h2>Theatre</h2>
        </span>
    )
}